import { SVGProps } from "react"

interface ProjectStepIconProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean
}

const ProjectStepIcon = (props: ProjectStepIconProps) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="50"
      height="50"
      rx="25"
      fill={props.isActive ? "#2768A3" : "#ABB7C2"}
      fillOpacity={props.isActive ? "1" : "0.1"}
    />
    <path
      d="M28.58 18.08L23.12 15.26C22.22 14.79 21.18 14.79 20.27 15.26L14.81 18.08C14.17 18.41 13.77 19.08 13.77 19.82C13.77 20.56 14.17 21.23 14.81 21.56L20.27 24.38C20.72 24.61 21.22 24.73 21.72 24.73C22.22 24.73 22.72 24.61 23.17 24.38L28.63 21.56C29.27 21.23 29.67 20.56 29.67 19.82C29.57 19.08 29.17 18.41 28.58 18.08Z"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.27 23L14.77 23.78C14.14 24.1 13.72 24.76 13.72 25.49C13.72 26.22 14.14 26.88 14.77 27.2L20.27 30.04C20.72 30.27 21.22 30.39 21.72 30.39C22.22 30.39 22.72 30.27 23.17 30.04L28.67 27.2C29.3 26.88 29.72 26.22 29.72 25.49C29.72 24.76 29.3 24.1 28.67 23.78L27.17 23"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.27 28.66L14.77 29.44C14.14 29.76 13.72 30.42 13.72 31.15C13.72 31.88 14.14 32.54 14.77 32.86L20.27 35.7C20.72 35.93 21.22 36.05 21.72 36.05C22.22 36.05 22.72 35.93 23.17 35.7L28.67 32.86C29.3 32.54 29.72 31.88 29.72 31.15C29.72 30.42 29.3 29.76 28.67 29.44L27.17 28.66"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.5 28V21"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.5 18C33.6046 18 34.5 17.1046 34.5 16C34.5 14.8954 33.6046 14 32.5 14C31.3954 14 30.5 14.8954 30.5 16C30.5 17.1046 31.3954 18 32.5 18Z"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ProjectStepIcon
